// config/testimonialConfig.js
export const testimonialConfig = {
  // Global settings for your project
  title: "What Our Customers Say",
  backgroundColor: "gray.50",
  titleColor: "gray.800",
  textColor: "gray.700",
  authorColor: "gray.800",
  colorScheme: "blue",
  autoPlay: false,
  autoPlayInterval: 5000,
  showAvatars: true,
  showNavigation: true,
  showDots: true,
  containerMaxWidth: "7xl",
  contentMaxWidth: "5xl",
};

// Different configurations for different sections
export const homePageTestimonialConfig = {
  title: "Check what these clients have to say",
  backgroundColor: "white",
  autoPlay: true,
  autoPlayInterval: 6000,
  showNavigation: true,
  showDots: true,
};

export const aboutPageTestimonialConfig = {
  title: "Client Success Stories",
  backgroundColor: "blue.50",
  colorScheme: "teal",
  showNavigation: false,
};
